import TutorDetails from './TutorDetails';

export default TutorDetails;
